.#{$namespace}-pagination {
	--pagination-font-size: #{$font-size};
	--pagination-font-size-small: calc(#{$font-size} - 2px);
	--pagination-button-color: #{$text-secondary-color};
	--pagination-text-color: #{$text-secondary-color};
	--pagination-bg-color: transparent;
	--pagination-button-bg-color: #{$border-lighter-color};
	--pagination-button-width: 32px;
	--pagination-button-height: #{$control-height};
	--pagination-button-width-small: 24px;
	--pagination-button-height-small: 24px;
	--pagination-button-width-large: 40px;
	--pagination-button-height-large: 40px;
	--pagination-button-disabled-color: #{$text-placeholder-color};
	--pagination-button-disabled-bg-color: transparent;
	--pagination-hover-color: #{color-token(primary)};
	--pagination-border-radius: 4px;
	--pagination-item-gap: 16px;

	display: flex;
	align-items: center;
	font-size: var(--pagination-font-size);
	font-weight: normal;
	color: var(--pagination-text-color);
	white-space: nowrap;

	// 上一页 / 下一页 / 页码钮共用
	.btn-prev,
	.btn-next,
	.#{$namespace}-pager li {
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		min-width: var(--pagination-button-width);
		height: var(--pagination-button-height);
		padding: 0 4px;
		border: none;
		border-radius: var(--pagination-border-radius);
		background: var(--pagination-bg-color);
		font-size: var(--pagination-font-size);
		line-height: var(--pagination-button-height);
		color: var(--pagination-button-color);
		text-align: center;
		cursor: pointer;

		// 点到内部 Svg 仍算点按钮，避免 target 不是 li
		* {
			pointer-events: none;
		}

		&:focus {
			outline: none;
		}

		&:hover {
			color: var(--pagination-hover-color);
		}

		&.is-active {
			font-weight: bold;
			color: var(--pagination-hover-color);
			cursor: default;
		}

		&:disabled,
		&.is-disabled {
			color: var(--pagination-button-disabled-color);
			background-color: var(--pagination-button-disabled-bg-color);
			cursor: not-allowed;
		}

		&:focus-visible {
			outline: 1px solid var(--pagination-hover-color);
			outline-offset: -1px;
		}
	}

	.btn-prev,
	.btn-next {
		margin-left: var(--pagination-item-gap);

		.#{$namespace}-svg {
			display: block;
			width: 1em;
			height: 1em;
			font-size: 12px;
			font-weight: bold;
		}
	}

	// 首尾外边距清零，避免 layout 首项多出一截空隙
	& > .is-first,
	& > *:first-child {
		margin-left: 0;
	}

	&__sizes {
		margin-left: var(--pagination-item-gap);
		font-weight: normal;
		color: #{$text-secondary-color};

		.#{$namespace}-select {
			width: 128px;
		}
	}

	&__total {
		margin-left: var(--pagination-item-gap);
		font-weight: normal;
		color: #{$text-secondary-color};

		&.is-disabled {
			color: #{$text-placeholder-color};
		}
	}

	&__jump {
		display: flex;
		align-items: center;
		margin-left: var(--pagination-item-gap);
		font-weight: normal;
		color: #{$text-secondary-color};

		&.is-disabled {
			color: #{$text-placeholder-color};
		}
	}

	&__goto {
		margin-right: 8px;
	}

	&__editor {
		box-sizing: border-box;
		width: 56px;
		text-align: center;

		.#{$namespace}-number,
		.#{$namespace}-input {
			width: 100%;
		}
	}

	&__classifier {
		margin-left: 8px;
	}

	&__rightwrapper {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: flex-end;
	}

	// 背景块模式：页码 / 上下页有浅底，激活用主色
	&.is-background {
		.btn-prev,
		.btn-next,
		.#{$namespace}-pager li {
			margin: 0 4px;
			background-color: var(--pagination-button-bg-color);

			&.is-active {
				background-color: #{color-token(primary)};
				color: #{$white-color};
			}

			&:disabled,
			&.is-disabled {
				color: #{$text-placeholder-color};
				background-color: #{$border-lighter-color};

				&.is-active {
					color: #{$text-secondary-color};
					background-color: #{$border-light-color};
				}
			}
		}

		.btn-prev {
			margin-left: var(--pagination-item-gap);
		}
	}

	&.#{$namespace}-pagination--small {
		.btn-prev,
		.btn-next,
		.#{$namespace}-pager li {
			min-width: var(--pagination-button-width-small);
			height: var(--pagination-button-height-small);
			font-size: var(--pagination-font-size-small);
			line-height: var(--pagination-button-height-small);
		}

		span:not([class*='suffix']),
		button {
			font-size: var(--pagination-font-size-small);
		}

		.#{$namespace}-select {
			width: 100px;
		}
	}

	&.#{$namespace}-pagination--large {
		.btn-prev,
		.btn-next,
		.#{$namespace}-pager li {
			min-width: var(--pagination-button-width-large);
			height: var(--pagination-button-height-large);
			line-height: var(--pagination-button-height-large);
		}

		.#{$namespace}-select {
			width: 160px;
		}
	}
}

.#{$namespace}-pager {
	display: flex;
	align-items: center;
	margin: 0;
	padding: 0;
	list-style: none;
	user-select: none;
	font-size: 0;

	// 「更多」悬停 / 聚焦时切双箭头
	li.more {
		position: relative;

		.pager-more-icon--active {
			display: none;
		}

		&:hover:not(.is-disabled),
		&:focus-visible:not(.is-disabled) {
			.pager-more-icon--idle {
				display: none;
			}

			.pager-more-icon--active {
				display: block;
			}
		}
	}
}
